<div class="d-flex justify-content-between align-items-center m-0 ps-4 pe-2 py-3">
  <p class="popup-header font-bold mb-0">Update Business Phone Number</p>
  <button mat-icon-button><mat-icon matDialogClose>cancel</mat-icon></button>
</div>

<mat-divider></mat-divider>

<div class="popup-wr p-4">
  <form class="row mt-0" [formGroup]="formUpdateContact" (ngSubmit)="onSubmit()">

    <div class="col-12 mb-3">
        <mat-form-field class="w-100" appearance="legacy">
            <mat-label>Business phone number (business hours)</mat-label>
            <input matInput placeholder="Mobile number" formControlName="phoneBusinessHours">
            <mat-error *ngIf="!f['phoneBusinessHours'].errors?.['required']">
                Please enter business phone number (business hours).
            </mat-error>
            <!-- <mat-error *ngIf="f['phoneBusinessHours'].errors?.['required'] && f['phoneBusinessHours'].errors?.['pattern']">
                Please enter valid business phone number (business hours).
            </mat-error> -->
        </mat-form-field>
    </div>

    <div class="col-12 mb-3">
        <mat-form-field class="w-100" appearance="legacy">
            <mat-label>Business phone number (after hours)</mat-label>
            <input matInput placeholder="Business Phone number" formControlName="phoneAfterHours">
            <mat-error *ngIf="!f['phoneAfterHours'].errors?.['required']">
                Please enter business phone number (after hours).
            </mat-error>
            <!-- <mat-error *ngIf="f['phoneAfterHours'].errors?.['required'] && f['phoneAfterHours'].errors?.['pattern']">
                Please enter valid business phone number (after hours).
            </mat-error> -->
        </mat-form-field>
    </div>

    <div class="col-12 action-btns text-right w-100 mt-3">
        <div class="d-flex align-items-center justify-content-end">
            <button class="btn primary shadow-none" mat-raised-button [disabled]="isLoading">Update</button>
            <mat-spinner class="ms-2" diameter="25" *ngIf="isLoading"></mat-spinner>
        </div>
    </div>
  </form>
</div>